import { z } from "zod/v4";
import { OcpiDateTime } from "../ocpi.utils";
import { DisplayText } from "./_common";

const TokenType = z.enum(["OTHER", "RFID"]);

const WhitelistType = z.enum(["ALWAYS", "ALLOWED", "ALLOWED_OFFLINE", "NEVER"]);

export const Token = z.object({
  uid: z.string().max(36),
  type: TokenType,
  auth_id: z.string().max(36),
  visual_number: z.string().max(64).nullish(),
  issuer: z.string().max(64),
  valid: z.boolean(),
  whitelist: WhitelistType,
  language: z.string().length(2).nullish(),
  last_updated: OcpiDateTime,
});

export const Tokens = z.array(Token);

export const LocationReferences = z.object({
  location_id: z.string().max(39),
  evse_uids: z.array(z.string().max(39)).nullish(),
  connector_ids: z.array(z.string().max(36)).nullish(),
});

export const AuthorizationInfo = z.object({
  allowed: z.enum([
    "ALLOWED",
    "BLOCKED",
    "EXPIRED",
    "NO_CREDIT",
    "NOT_ALLOWED",
  ]),
  location: LocationReferences.nullish(),
  info: DisplayText.nullish(),
});
